export const C240LoaderActions = {
    UPDATE_C240_EDITOR_MODE : "UPDATE_C240_EDITOR_MODE",
    UPDATE_BANNER_STATE: "UPDATE_BANNER_STATE",
    UPDATE_LOADER_STATE: "UPDATE_LOADER_STATE"
}